// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2jcO_","label":"Radio_label__2ATRK","checkMark":"Radio_checkMark__1ogZa","disabled":"Radio_disabled__Rh_PY"};